import { render, staticRenderFns } from "./MakeRepair.vue?vue&type=template&id=345eba5c"
import script from "./MakeRepair.vue?vue&type=script&lang=js"
export * from "./MakeRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports